
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Swiftdzireonrentinpune() {



    const cardData =
    {
        keyword: ' Swift Dzire On Rent in Pune',
        heading: 'Prince Cabs: Swift Dzire On Rent in Pune',
        headingDescription: 'Prince Cabs provides affordable Swift Dzire on Rent in Pune, ideal for local travel, airport transfers, corporate rides, and outstation journeys. Our well-maintained Swift Dzire cars are fuel-efficient, comfortable, and perfect for budget-friendly travel. With professional chauffeurs, flexible booking options, and on-time pickups, we ensure a smooth and hassle-free ride across Pune and beyond. Experience reliability, safety, and convenience with Prince Cabs’ trusted Swift Dzire rental service in Pune.',

        top: 'Top Places to Visit in Mumbai with Prince Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s most iconic landmark overlooking the Arabian Sea. Constructed in Indo-Saracenic style, it commemorates the visit of King George V and Queen Mary. The site is a bustling hub with tourists, photographers, and ferry rides to Elephanta Caves. At sunset, the arch glows beautifully against the skyline. It remains the proud symbol of South Mumbai. Gateway of India is the city’s historic and cultural centerpiece."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6 km crescent-shaped boulevard along the Arabian Sea. Locals and tourists flock here for evening walks, sea breezes, and stunning sunsets. At night, its streetlights resemble a sparkling necklace. During monsoon, waves dramatically crash against the promenade. It reflects the modern, vibrant spirit of Mumbai. Marine Drive is the heart of the city’s leisure life."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST, formerly Victoria Terminus, is a UNESCO World Heritage railway station built in 1887. Its Gothic Revival architecture features domes, spires, stained glass windows, and intricate carvings. The building looks spectacular when illuminated at night. It is both a functional transport hub and a heritage monument. Tourists admire its grandeur while witnessing Mumbai’s lifeline—the local trains. CST symbolizes Mumbai’s blend of history and modernity."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, located on Elephanta Island, are UNESCO-listed rock-cut temples dating to the 5th–6th centuries. The highlight is the magnificent Trimurti sculpture of Lord Shiva. The caves reflect India’s ancient artistry and spiritual traditions. Accessible by ferry from Gateway of India, the island offers peace away from the city. Lush greenery surrounds the caves, enhancing their charm. It is a must-visit for history and culture lovers."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most famous beach, popular for street food and leisure walks. Vendors serve local delights like pav bhaji, bhel puri, and ice gola. Families gather in the evenings to enjoy the sea breeze and sunset. Bollywood celebrities residing nearby make it a star-spotting zone. The beach is lively with children playing and locals exercising. Juhu Beach is Mumbai’s vibrant coastal escape."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most visited shrines, dedicated to Lord Ganesha. Built in 1801, it attracts devotees, celebrities, and politicians daily. The golden dome and beautifully carved wooden doors add grandeur. Tuesdays are especially crowded with worshippers. Devotees believe wishes made here are fulfilled. Siddhivinayak Temple is the spiritual core of Mumbai."
  },
  {
    "title": "Bandra–Worli Sea Link",
    "description": "The Bandra–Worli Sea Link is an eight-lane cable-stayed bridge and an engineering marvel. It connects South Mumbai with the western suburbs, reducing travel time significantly. The bridge offers stunning views of the Arabian Sea and skyline. At night, its illuminated structure looks spectacular. Driving across the Sea Link is a thrilling experience. It is a modern symbol of Mumbai’s progress."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, built in the 15th century, is a revered shrine located on an islet in the Arabian Sea. Dedicated to Pir Haji Ali Shah Bukhari, it is a blend of spirituality and architecture. The dargah is connected by a causeway accessible at low tide. Devotees from all religions visit to seek blessings. Its sea-facing setting creates a serene atmosphere. Haji Ali is Mumbai’s iconic spiritual landmark."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s bustling street market and shopping paradise. Visitors shop for clothes, handicrafts, jewelry, and antiques at bargain prices. Iconic cafés like Leopold Café and Café Mondegar add to the charm. The area is always lively with both locals and tourists. Bargaining with street vendors is part of the fun. Colaba Causeway is the ultimate shopping and cultural hotspot of Mumbai."
  },
  {
    "title": "Girgaon Chowpatty",
    "description": "Girgaon Chowpatty is a lively beach in South Mumbai, famous for Ganesh Visarjan celebrations. Families and couples enjoy snacks like pav bhaji, kulfi, and bhel here. The beach is vibrant during evenings and festivals. It offers views of Marine Drive’s arc and the Arabian Sea. Children love playing in the sand and waves. Girgaon Chowpatty is Mumbai’s blend of tradition and leisure."
  },
  {
    "title": "Film City, Goregaon",
    "description": "Film City in Goregaon is the hub of Bollywood filmmaking, spread over 500 acres. It has studios, artificial sets, and shooting zones for films and TV shows. Guided tours take visitors behind the scenes of movie production. Cinema lovers enjoy spotting live shoots. It is one of the largest film complexes in the world. Film City showcases Mumbai’s entertainment identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Sanjay Gandhi National Park is a vast green sanctuary within Mumbai, covering 87 sq. km. It is home to leopards, deer, and hundreds of bird species. Inside the park, the Kanheri Caves display Buddhist stupas and rock-cut monasteries dating back to the 1st century BC. Visitors enjoy safaris, toy train rides, and treks. It is rare to find such nature in a metro. This park blends history, wildlife, and adventure."
  },
  {
    "title": "Powai Lake",
    "description": "Powai Lake is an artificial lake surrounded by greenery and skyscrapers. It is popular among birdwatchers, with species like herons and kingfishers often spotted. Joggers and photographers enjoy its promenade. During monsoon, the lake looks especially scenic with misty surroundings. It is a peaceful retreat within the bustling city. Powai Lake is Mumbai’s hidden natural gem."
  },
  {
    "title": "Global Vipassana Pagoda",
    "description": "The Global Vipassana Pagoda near Gorai is one of the world’s largest meditation domes. Built in Burmese architectural style, it houses relics of Buddha. The golden dome accommodates thousands of meditators. Visitors attend meditation sessions and admire the grand design. Its seaside setting enhances tranquility. The pagoda symbolizes peace, spirituality, and harmony."
  },
  {
    "title": "Nehru Planetarium & Science Centre",
    "description": "Nehru Planetarium in Worli is an educational hub for astronomy enthusiasts. Sky shows inside its dome theatre explain stars, galaxies, and cosmic wonders. The adjoining Science Centre offers interactive exhibits on innovation and technology. Families and students find it educational yet entertaining. Special events are held during eclipses and celestial events. It is Mumbai’s hub of science and curiosity."
  }
],

"services": [
  {
    "name": "Dzire Taxi Hire Pune",
    "description": "Hire Dzire taxis in Pune for comfortable and reliable travel within the city or for outstation trips. Perfect for solo travelers, couples, or small families seeking economical yet quality transportation with professional drivers and well-maintained vehicles."
  },
  {
    "name": "Swift Dzire Rental with Driver Pune",
    "description": "Rent Swift Dzire cars with experienced drivers in Pune for hassle-free travel. Ideal for daily commutes, business trips, and leisure travel, ensuring timely pickups, smooth rides, and a safe journey."
  },
  {
    "name": "Swift Dzire for Outstation Pune",
    "description": "Book Swift Dzire cabs for outstation trips from Pune to nearby destinations such as Mumbai, Goa, and Shirdi. Enjoy a comfortable ride with ample luggage space and a courteous driver for long-distance travel."
  },
  {
    "name": "Pune to Mumbai Dzire Cab",
    "description": "Affordable and punctual Dzire taxi service from Pune to Mumbai, offering a smooth and comfortable ride. Perfect for business travelers and tourists looking for a budget-friendly option with quality service."
  },
  {
    "name": "Dzire for Local Travel Pune",
    "description": "Convenient Dzire cab services for local travel within Pune. Whether it's airport drop, shopping trips, or daily commutes, our Dzire taxis provide a reliable and comfortable ride."
  },
  {
    "name": "Dzire for Pune to Goa",
    "description": "Plan your scenic trip to Goa with our Dzire taxi rentals from Pune. Experience a comfortable and economical journey with friendly drivers and safe travel arrangements."
  },
  {
    "name": "Dzire for Pune to Shirdi",
    "description": "Travel to the holy city of Shirdi from Pune in a Dzire cab, ensuring a peaceful and hassle-free trip. Ideal for pilgrims and tourists seeking comfort and reliability on the road."
  },
  {
    "name": "Dzire Cab Booking Pune",
    "description": "Easy and quick Dzire cab bookings in Pune for any occasion, including local travel, outstation trips, and special events. Enjoy transparent pricing, timely service, and professional drivers."
  },
  {
    "name": "Dzire on Rent Hinjewadi",
    "description": "Avail Dzire rental services in the Hinjewadi area for corporate travel, office commutes, or personal use. Benefit from affordable rates, punctual pickups, and comfortable rides."
  },
  {
    "name": "Dzire on Rent in Kharadi",
    "description": "Rent Dzire cars in Kharadi for smooth local or outstation travel. Perfect for business travelers, family outings, and daily transportation needs with well-maintained vehicles."
  },
  {
    "name": "Dzire Car for Wedding Pune",
    "description": "Make your special day memorable with our stylish Dzire car rentals for weddings in Pune. Elegant and well-kept vehicles with professional chauffeurs to ensure a grand arrival."
  },
  {
    "name": "Dzire for Corporate Travel Pune",
    "description": "Reliable Dzire taxi services for corporate clients in Pune. Comfortable rides, timely pickups, and professional drivers make your business travel seamless and productive."
  },
  {
    "name": "Affordable Dzire Rental Pune",
    "description": "Get budget-friendly Dzire car rental options in Pune without compromising on service quality. Perfect for travelers seeking economical yet comfortable transportation."
  },
  {
    "name": "Swift Dzire Hire in Viman Nagar",
    "description": "Swift Dzire cabs available for hire in Viman Nagar, Pune. Ideal for airport transfers, local travel, and outstation trips with professional drivers and well-maintained cars."
  },
  {
    "name": "Dzire on Rent for Family Trip",
    "description": "Plan your family outings and trips with our Dzire rental services, offering spacious seating, smooth rides, and reliable service to make your journey enjoyable and stress-free."
  }
],
"tableData": [
  ["Dzire Taxi Hire Pune", "Swift Dzire Rental with Driver Pune"],
  ["Swift Dzire for Outstation Pune", "Pune to Mumbai Dzire Cab"],
  ["Dzire for Local Travel Pune", "Dzire for Pune to Goa"],
  ["Dzire for Pune to Shirdi", "Dzire Cab Booking Pune"],
  ["Dzire on Rent Hinjewadi", "Dzire on Rent in Kharadi"],
  ["Dzire Car for Wedding Pune", "Dzire for Corporate Travel Pune"],
  ["Affordable Dzire Rental Pune", "Swift Dzire Hire in Viman Nagar"],
  ["Dzire on Rent for Family Trip"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Swift Dzire Rental Service in Pune",
    "WhyChoosedescription": "Prince Cabs offers a trusted and convenient Swift Dzire rental service in Pune, perfect for business trips, family outings, and city travel. Our rental service ensures you have a comfortable, fuel-efficient, and stylish vehicle at your disposal, with professional support and hassle-free booking."
  },
  {
    "WhyChooseheading": "Well-Maintained and Comfortable Swift Dzire Cars",
    "WhyChoosedescription": "Our Swift Dzire cars are regularly serviced and maintained to guarantee smooth performance and reliability. Equipped with air conditioning, spacious interiors, and comfortable seating, these sedans provide an enjoyable driving and riding experience within Pune and nearby areas."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages to Suit Your Needs",
    "WhyChoosedescription": "Choose from various rental packages including hourly, daily, and long-term rentals. Whether you need a Swift Dzire for a few hours, a day trip, or an extended period, Prince Cabs offers customizable options with transparent pricing and flexible cancellation policies."
  },
  {
    "WhyChooseheading": "Experienced Drivers and Self-Drive Options",
    "WhyChoosedescription": "Opt for a professional driver who knows Pune’s routes well, ensuring timely arrivals and safe driving, or choose our self-drive rental option for complete control over your trip. All drivers are background-checked and trained for courteous service and passenger safety."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our Swift Dzire rental rates in Pune are competitive and fully transparent. The fare includes fuel, taxes, driver allowance (if applicable), and tolls. Multiple payment methods such as UPI, credit/debit cards, net banking, and cash are accepted for your convenience."
  },
  {
    "WhyChooseheading": "Sanitized and Well-Maintained Vehicles for Your Safety",
    "WhyChoosedescription": "Every Swift Dzire car is thoroughly cleaned and sanitized before each rental to ensure your safety and comfort. Regular maintenance and essential safety features like seat belts and airbags provide a secure and worry-free experience."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Hassle-Free Rentals",
    "WhyChoosedescription": "Prince Cabs’ customer care team is available around the clock to assist you with booking, trip modifications, and any other queries. Our goal is to provide a seamless and enjoyable rental experience with our Swift Dzire cars in Pune."
  }
]





























    }

const faqData = [
    {
        question: 'Can I rent a Swift Dzire in Pune through Prince Cabs?',
        answer: 'Yes, Prince Cabs offers Swift Dzire cars on rent in Pune for both short and long-term travel needs.',
    },
    {
        question: 'What are the rental options available for Swift Dzire in Pune?',
        answer: 'We provide flexible rental options including hourly, daily, and outstation packages to suit your requirements.',
    },
    {
        question: 'Is the Swift Dzire well-maintained and sanitized?',
        answer: 'Absolutely! All our Swift Dzire cars are regularly serviced, cleaned, and sanitized for your safety and comfort.',
    },
    {
        question: 'Can I hire a Swift Dzire with a driver?',
        answer: 'Yes, our Swift Dzire rentals come with professional and courteous drivers to ensure a hassle-free journey.',
    },
    {
        question: 'What is the rental fare for a Swift Dzire in Pune?',
        answer: 'Rental fares vary depending on the duration and type of package. Please contact Prince Cabs for a personalized quote.',
    },
    {
        question: 'How do I book a Swift Dzire on rent in Pune?',
        answer: 'You can easily book through our website or by calling our customer support team for quick confirmation.',
    },
    {
        question: 'Are there any special packages for Swift Dzire rentals in Pune?',
        answer: 'Yes, Prince Cabs offers special packages for corporate clients, airport transfers, and long-distance travel.',
    },
];

const testimonials = [
    {
        name: "Mr. Aditya Sharma",
        position: "Corporate Client",
        text: "I frequently rent Swift Dzire from Prince Cabs in Pune. The cars are clean, drivers are professional, and service is reliable.",
        image: "/img/testimonial/testimonial-thumb-swift-dzire-pune-1.png",
    },
    {
        name: "Ms. Sneha Kulkarni",
        position: "Tourist",
        text: "Renting a Swift Dzire from Prince Cabs made my Pune trip easy and comfortable. Highly recommended!",
        image: "/img/testimonial/testimonial-thumb-swift-dzire-pune-2.png",
    },
];











































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Swift Dzire On Rent in Pune",
  "description": "Swift Dzire rental services in Pune for outstation trips, local travel, corporate events, weddings, and family trips. Affordable rental with driver available in Hinjewadi, Kharadi, Viman Nagar, and more.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Dzire Taxi Hire Pune",
    "Swift Dzire Rental with Driver Pune",
    "Swift Dzire for Outstation Pune",
    "Pune to Mumbai Dzire Cab",
    "Dzire for Local Travel Pune",
    "Dzire for Pune to Goa",
    "Dzire for Pune to Shirdi",
    "Dzire Cab Booking Pune",
    "Dzire on Rent Hinjewadi",
    "Dzire on Rent in Kharadi",
    "Dzire Car for Wedding Pune",
    "Dzire for Corporate Travel Pune",
    "Affordable Dzire Rental Pune",
    "Swift Dzire Hire in Viman Nagar",
    "Dzire on Rent for Family Trip"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};




    return (
        <div>
<Helmet>
  <title>Swift Dzire On Rent in Pune | Affordable Dzire Taxi with Driver</title>
  <meta
    name="description"
    content="Rent Swift Dzire with driver in Pune for outstation, local travel, weddings, corporate trips, and family outings. Affordable Dzire rental available in Hinjewadi, Kharadi, Viman Nagar & more."
  />
  <meta
    name="keywords"
    content="Dzire Taxi Hire Pune, Swift Dzire Rental with Driver Pune, Swift Dzire for Outstation Pune, Pune to Mumbai Dzire Cab, Dzire for Local Travel Pune, Dzire for Pune to Goa, Dzire for Pune to Shirdi, Dzire Cab Booking Pune, Dzire on Rent Hinjewadi, Dzire on Rent in Kharadi, Dzire Car for Wedding Pune, Dzire for Corporate Travel Pune, Affordable Dzire Rental Pune, Swift Dzire Hire in Viman Nagar, Dzire on Rent for Family Trip"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/68.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Swiftdzireonrentinpune ;